import { render, staticRenderFns } from "./CreateReport.vue?vue&type=template&id=54c1b086"
import script from "./CreateReport.vue?vue&type=script&lang=js"
export * from "./CreateReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports